import React from "react";

export interface QuoteProps {
  width?: number;
  height?: number;
  color?: string;
}

const Quote: React.FC<QuoteProps> = ({ width = 42, height = 28, color = "#226CF5" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 42 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.53809 28.002C4.28637 28.0017 0.0292972 23.7439 0.0292977 18.4922C0.0293034 18.3695 0.0334786 18.2475 0.0380868 18.126L0.0273446 18.1387C-0.324853 13.2959 2.63367 2.88803 17.2852 -1.541e-07C14.481 1.41594 8.68087 5.18169 6.75 9.40039C7.63186 9.13026 8.56775 8.98344 9.53809 8.9834C14.7898 8.9834 19.0476 13.2405 19.0479 18.4922C19.0479 23.7441 14.79 28.002 9.53809 28.002Z"
        fill={color}
      />
      <path
        d="M32.4746 28.002C27.2229 28.0017 22.9658 23.7439 22.9658 18.4922C22.9658 18.3702 22.9701 18.2488 22.9746 18.1279L22.9639 18.1406C22.6117 13.2979 25.5702 2.88999 40.2217 0.00195297C37.418 1.41768 31.6193 5.18249 29.6875 9.40039C30.5691 9.13044 31.5046 8.98344 32.4746 8.9834C37.7264 8.9834 41.9842 13.2405 41.9844 18.4922C41.9844 23.7441 37.7265 28.002 32.4746 28.002Z"
        fill={color}
      />
    </svg>
  );
};

export default Quote;
